export enum Route {
  HOME = '',
  LOGIN = 'login',
  INSERATE = 'inserate',
  ANGEBOTE = 'angebote',
  PARTNERS = 'partner',
  ACCOUNT = 'account',
  HELP = 'hilfe',
  NMS = 'nms',
  INSERAT_ERSTELLEN = 'inserat-erstellen',
  MEMBER_ERSTELLEN = 'member-erstellen',
  USER_PAGE = 'profil',
  COMPANY_PROFILE = 'unternehmensprofil',
  BOERSENNOTE = 'boersennote',
  INSERAT_ANGEBOTE = 'inserat-angebote',
  CREATE_USER = 'nutzer-erstellen',
  CREATE_COMPANY = 'firma-erstellen',
  PROPOSAL_DETAILS = 'inserat-details',
  ABOUT = 'about',
  IMPRINT = 'impressum',
  DATAPROTECTION = 'datenschutzerklärung',
  CONTACT = 'kontakt',
  DOWNLOADS = 'Downloadbereich',
  TUTORIAL = 'Tutorial',
  ONBOARDING = 'Onboarding',
  ONBOARDING_CA = 'OnboardingCA',
  SHOWCASE = 'Showcase',
  CREATE_OFFER = 'angebot-erstellen',
  CREATE_EXTERNAL_COVERAGE = 'create-external-coverage',
  EVENT = "Veranstaltungen",
  PROPOSAL_PREVIEW = "inserat-preview",
  BILL_BOARD = "bill-board",
  MEMBER_OVERVIEW = "member-overview",
  MAILINGS = "mailings",
  OFFER_PREVIEW = "angebot-preview",
  ERROR_ROLE = 'error-role',
}
